import { useContext, useEffect, useState } from 'react';
import io from 'socket.io-client';

// CONTEXT
import { AuthContext } from 'context/AuthContext';

const socket = io(process.env.REACT_APP_API_URL);

export function useSocket() {
    const { email } = useContext(AuthContext);
    const [connectedUsers, setConnectedUsers] = useState(0);

    useEffect(() => {
        // Confirmation de la connexion
        socket.on('connected', (data) => {
            // ...
        });

        if (email) {
            socket.emit('user_connected', email);
        }

        const handleUserCountUpdate = (data) => {
            setConnectedUsers(data.count);
        };

        socket.on('update_user_count', handleUserCountUpdate);

        return () => {
            socket.off('connected');
            socket.off('update_user_count', handleUserCountUpdate);
        };
    }, [email]);

    return { socket, connectedUsers };
}